import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit,
} from '@angular/core';
import { AbstractContentInitializer } from '../../../cross-team-shared/abstract-content-initializer';
import { AbstractSensorContentStore } from '../../../cross-team-shared/state/abstract-sensor-content-store';
import { AbstractAssetInitializationService } from '../../shared/asset-loading/abstract-asset-initialization.service';
import { contentProviders2D } from '../../shared/content-providers-2d';
import { AbstractSensorContentStore2D } from '../../shared/state/abstract-sensor-content-store-2d';
import { VideoContentState } from '../state/video-content-state';
import { VideoContentStateUndoService } from '../state/video-content-state-undo.service';
import { VideoContentStore } from '../state/video-content-store';
import { VideoAssetInitializationService } from '../utils/loading/video-asset-initialization.service';
import { VideoPerFrameAssetLoadingService } from '../utils/loading/video-per-frame-asset-loading.service';
import { VideoContentConnector } from '../video-content-connector';
import { VideoLayerSettingsService } from './video-layer-settings.service';

@Component({
  selector: 'h3-video-content-initializer',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    contentProviders2D,
    VideoAssetInitializationService,
    VideoLayerSettingsService,
    VideoPerFrameAssetLoadingService,
    {
      provide: AbstractAssetInitializationService,
      useExisting: VideoAssetInitializationService,
    },
    {
      provide: VideoContentStore,
      useFactory: () => new VideoContentStore(new VideoContentState()),
    },
    VideoContentStateUndoService,
    { provide: AbstractSensorContentStore, useExisting: VideoContentStore },
    { provide: AbstractSensorContentStore2D, useExisting: VideoContentStore },
    VideoContentConnector,
  ],
  standalone: false,
})
export class VideoContentInitializerComponent
  extends AbstractContentInitializer<VideoContentConnector>
  implements OnInit
{
  constructor(
    injector: Injector,
    protected override store: VideoContentStore,
    private layerSettingsService: VideoLayerSettingsService,
  ) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();

    if (!this.store.state().project.use_annotation_store) {
      this.injector
        .get(VideoContentStore)('layerSettings')
        .set(this.layerSettingsService.getInitialSettings());
    }

    this.store('frameNumber').set(this.frameNumber);
  }

  protected getContentConnector() {
    return this.injector.get(VideoContentConnector);
  }

  protected override setUpSubscriptions(store: AbstractSensorContentStore) {
    super.setUpSubscriptions(store);
    if (this.store.state().project.use_annotation_store) {
      this.subscribeTo(this.settingsStore('layerSettings2d').$, (settings) =>
        this.store('layerSettings').set(settings),
      );

      this.subscribeTo(
        this.store('layerSettings')('zoomPanelScale').$,
        (scale) => this.shellConnector.setZoomPanelSettings(scale),
      );
    }

    this.subscribeTo(this.settingsStore('viewMode').$, (viewMode) =>
      this.store('viewMode').set(viewMode),
    );
  }
}
